import discardForwardingOption from './actions/discardForwardingOption';
import saveForwardingOption from './actions/saveForwardingOption';
import ForwardingFull from './components/ForwardingFull';
import isForwardingFormInvalid from './utils/isForwardingFormInvalid';
import isForwardingOptionDirty from './utils/isForwardingOptionDirty';
import * as React from 'react';
var ForwardingOption = {
    key: 'forwardingOption',
    titleStringKey: 'optionTitle_forwarding',
    hideTitleInFullOptions: true,
    searchTermsStringKey: 'optionTitle_forwarding',
    fullOptionFormSettings: {
        render: function () { return React.createElement(ForwardingFull, null); },
        isDirty: isForwardingOptionDirty,
        onSave: saveForwardingOption,
        onDiscard: discardForwardingOption,
        disableSave: isForwardingFormInvalid,
    },
};
export default ForwardingOption;
//# sourceMappingURL=ForwardingOption.js.map